export default {
  customFields: [
    {
      id: "8CD008AB-0145-45D8-967C-8C0B3627463F",
      name: "01. Income Insurance"
    },
    {
      id: "F28860AC-F58A-4AE8-9F22-66745130D19B",
      name: "02. Life Insurance"
    },
    {
      id: "21BFF459-35A0-4E40-86FA-6BD398FDF2D2",
      name: "03. Pet Insurance"
    },
    {
      id: "32C7B947-D061-43BC-9122-FC01CA192F47",
      name: "04. Travel Insurance"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/jsonData/CustomFields.js